import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from '../../../../../../node_modules/rxjs/dist/types';
import { ErrorDialogComponent } from './error-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorDialogService {
  constructor(private dialog: MatDialog) {}

  public open(title: string, message: string): Observable<boolean> {
    let dialogRef: MatDialogRef<ErrorDialogComponent>;

    dialogRef = this.dialog.open(ErrorDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;

    return dialogRef.afterClosed();
  }
}
